module.exports = __webpack_public_path__ + "def3060290911847fcfa84469e1c43d7.png";